<template>
  <el-table
    v-loading="loading"
    :data="dataSource"
    style="width: 100%"
    max-height="650"
    :row-key="rowKey"
    @selection-change="handleSelectionChange"
    v-if="columns.length > 0"
  >
    <el-table-column type="selection" width="55" v-if="selection" />
    <template v-for="item in columns" :key="item.prop">
      <!---scope使用组件时-->
      <el-table-column
        v-if="item.scopeComponent"
        :label="item.label"
        :width="item.width"
        :align="'center'"
      >
        <template #default="scope">
          <!---handleScope用于对scope数据二次处理，默认不传-->
          <component
            v-model="scope.row[item.prop]"
            :is="item.scopeComponent"
            :scope="item.handleScope ? item.handleScope(scope) : scope"
            @click="handleClick('scope', scope.row)"
          ></component>
        </template>
      </el-table-column>
      <!---scope使用函数时-->
      <el-table-column
        v-else-if="item.scopeFun"
        :label="item.label"
        :width="item.width"
        :align="'center'"
      >
        <template #default="scope">
          {{ item.scopeFun(scope) }}
        </template>
      </el-table-column>
      <!--默认的列表展现-->
      <el-table-column
        v-else
        :label="item.label"
        :width="item.width"
        :align="'center'"
      >
        <template #default="scope">
          {{ scope.row[item.prop] ? scope.row[item.prop] : "--" }}
        </template>
      </el-table-column>
    </template>
    <el-table-column
      fixed="right"
      label="操作"
      width="200"
      :align="'center'"
      v-if="actionColumn"
    >
      <!-- @slot 操作列的插槽 -->
      <template #default="scope">
        <slot name="column-btns" :scope="scope"></slot>
        <el-button
          link
          type="primary"
          @click="handleClick('detail', scope.row)"
          v-if="columnBtns && columnBtns.detail"
          >查看</el-button
        >
        <el-button
          link
          type="primary"
          @click="handleClick('export', scope.row)"
          v-if="columnBtns && columnBtns.export"
          :disabled="
            columnBtns.exportDisabled && columnBtns.exportDisabled(scope.row)
          "
          >导出</el-button
        >
        <el-button
          link
          type="primary"
          @click="handleClick('edit', scope.row)"
          v-if="columnBtns && columnBtns.edit"
          :disabled="
            columnBtns.editDisabled && columnBtns.editDisabled(scope.row)
          "
          >编辑</el-button
        >
        <el-button
          link
          type="danger"
          @click="handleClick('delete', scope.row)"
          v-if="columnBtns && columnBtns.delete"
          :disabled="
            columnBtns.deleteDisabled && columnBtns.deleteDisabled(scope.row)
          "
          >删除</el-button
        >
        <slot name="after-column-btns" :scope="scope"></slot>
      </template>
    </el-table-column>
  </el-table>
  <div class="table-pagination" v-if="page.total > 0">
    <el-pagination
      v-model:current-page="page.pageNumber"
      v-model:page-size="page.limit"
      :page-sizes="[10, 20, 30, 50]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  ref,
  getCurrentInstance,
  watch,
  onMounted,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import tableMixin from "./tableMixin";
export default defineComponent({
  name: "basicTable",
  emits: {
    /** scopeComponent有值时，自定义组件的click方法
     * @event changeCheck
     * @param {string} type 值为scope
     * @param {object} item 当前行
     */
    action: null,
  },
  mixins: [tableMixin],
  props: {},
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const { proxy } = getCurrentInstance();
    const treeRef = ref();
    const dialogRef = ref();
    const state = reactive({
      loading: false,
      dataSource: [],
      page: {
        limit: 10,
        pageNumber: 1,
        total: 0,
      },
      currentSelection: [],
    });

    const getData = () => {
      let date = {};
      // props.search.forEach((item) => {
      //   /*对日期和时间组件单独处理*/
      //   if (item.component === "el-date-picker" && item.date1 && item.date2) {
      //     if (state.form[item.value]) {
      //       date[item.date1] = state.form[item.value][0]
      //         ? state.form[item.value][0]
      //         : null;
      //       date[item.date2] = state.form[item.value][1]
      //         ? state.form[item.value][1]
      //         : null;
      //     } else {
      //       date[item.date1] = null;
      //       date[item.date2] = null;
      //     }
      //   }
      // });

      //删除为空的对象值
      // if (formParams.date) {
      //   delete formParams.date;
      // }
      // Object.keys(formParams).map((key) =>
      //   (!formParams[key] && formParams[key] !== 0) || formParams[key] == -1
      //     ? delete formParams[key]
      //     : ""
      // );
      console.log("props.tableParams---->", props.tableParams);

      if (props.api.list) {
        state.loading = true;
        let params = {
          ...props.tableParams,
          page: state.page.pageNumber,
          limit: state.page.limit,
        };
        if (props.beforeGet) {
          params = props.beforeGet(params);
        }
        proxy.$api[props.api.list](params, "get").then((res) => {
          state.loading = false;
          if (res.data) {
            if (res.data.records) {
              state.page.total = res.data.total;
              state.dataSource = props.afterGet
                ? props.afterGet(res.data.records)
                : res.data.records;
            } else {
              state.page.total = 0;
              state.dataSource = props.afterGet
                ? props.afterGet(res.data)
                : res.data;
            }
          }
        });
      }
    };

    //改变翻页的size
    const handleSizeChange = () => {
      getData();
    };
    //点击翻页
    const handleCurrentChange = () => {
      getData();
    };
    //表格选择
    const handleSelectionChange = (val) => {
      state.currentSelection = val;
      console.log("state.currentSelection--------->", state.currentSelection);
      emit("change", state.currentSelection);
    };
    const handleClick = (type, item) => {
      emit("click", type, item);
    };
    onMounted(() => {
      getData();
    });
    return {
      treeRef,
      dialogRef,
      ...toRefs(state),
      getData,
      handleClick,
      handleSizeChange,
      handleCurrentChange,
      handleSelectionChange,
    };
  },
});
</script>

<style lang="less" scoped>
.table-pagination {
  text-align: right;
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
<docs lang="md">
### props

###### api

- @param {string} list - 必传,列表接口
- @param {string} delete - 删除接口
- @param {string} deleteAll - 删除全部接口
- @param {string} export - 导出接口
- @param {string} add - 新增保存接口
- @param {string} edit - 编辑保存接口
- @param {string} detail - 详情接口
- @param {string} path - 详情页面路径

###### columns item

- @param {string} label - 必传,标签文本
- @param {string} prop - 必传,组件 model 的键名
- @param {string} width - 列表宽
- @param {function} scopeFun - 处理 el-table-column 中默认插槽数据的函数
- @param {string} scopeComponent - el-table-column 中插入的自定义组件
- @param {string} scope - scopeComponent 有值时给自定义组件传入当前行数据
- @param {function} handleScope - scopeComponent 有值时，处理当前行数据并传给自定义组件
- @param {array} custom - scopeComponent 有值时，给自定义组件的自定义数据
</docs>
